// extracted by mini-css-extract-plugin
module.exports = {"section":"HomePage_section__3ZraB"};